// extracted by mini-css-extract-plugin
module.exports = {"container":"SGSIconBadge_container__36F4j","green":"SGSIconBadge_green__3PqlZ","orange":"SGSIconBadge_orange__1o_6K"};